import {
  Container, Grid, Box, Button, Link
} from '@mui/material';
import { useStyles } from './style';

export const ThankYou = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container rowSpacing={{ xs: 4, sm: 4, md: 4 }} py={{ xs: 6, md: 4 }} justifyContent="center">
        <Grid item xs={12} sm={6} md={5}>
          <Box className={classes.imageWrapper}>
            <Box component="img" src="assets/images/Header_Logo.svg" />
          </Box>
        </Grid>
      </Grid>
      <Grid container rowSpacing={{ xs: 4, sm: 4, md: 4 }} py={{ xs: 6, md: 4 }} justifyContent="center" textAlign="center">
        <Grid item xs={12} sm={12} md={12}>
          <Box className={classes.textWrapper}>
            <Box fontSize={25} fontWeight={500}>All done!</Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Box className={classes.textWrapper}>
            <Box fontSize={25} fontWeight={400}>Thanks for registering.</Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container rowSpacing={{ xs: 4, sm: 4, md: 4 }} py={{ xs: 6, md: 4 }} justifyContent="center" textAlign="center">
        <Grid item xs={12} sm={12} md={12}>
          <Box className={classes.imageWrapper}>
            <Button component={Link} href="https://averhealth.com/" target="_blank" variant="contained" color="primary">Visit Averhealth.com</Button>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
